type DeliveryMode = "airplane" | "ship" | "train";
export type OrderStatus = "active" | "forecasted" | "completed";

export type PoOrder = {
  id: string;
  cogs: number;
  orderDate: Date;
  estCompleteDate: Date;
};

export type SoOrder = {
  id: string;
  shippingCost: number;
  shipmentDate: Date;
  delivaryDate: Date;
  mode: DeliveryMode;
};

export type Order = {
  id: string;
  po: PoOrder;
  so: SoOrder[];
  status: OrderStatus;
};

export const getTransportIcon = (mode: DeliveryMode) => {
  switch (mode) {
    case "airplane":
      return "✈️";
    case "ship":
      return "🚢";
    case "train":
      return "🚂";
    default:
      return null;
  }
};

export const getStatusColor = (status: OrderStatus) => {
  switch (status) {
    case "active":
      return "#80C67A";
    case "forecasted":
      return "#5295E0";
    case "completed":
      return "#6B4DBA";
    default:
      return "#A6A7A8";
  }
};

export const mockData: Order[] = [
  {
    id: "1",
    po: {
      id: "738291",
      cogs: 1000,
      orderDate: new Date("2024-01-01"),
      estCompleteDate: new Date("2024-01-15"),
    },
    so: [
      {
        id: "928391",
        shippingCost: 50,
        shipmentDate: new Date("2024-01-01"),
        delivaryDate: new Date("2024-01-07"),
        mode: "airplane",
      },
      {
        id: "120273",
        shippingCost: 100,
        shipmentDate: new Date("2024-01-05"),
        delivaryDate: new Date("2024-01-10"),
        mode: "ship",
      },
    ],
    status: "active",
  },
  {
    id: "2",
    po: {
      id: "728492",
      cogs: 1500,
      orderDate: new Date("2024-01-02"),
      estCompleteDate: new Date("2024-01-20"),
    },
    so: [
      {
        id: "190273",
        shippingCost: 100,
        shipmentDate: new Date("2024-01-05"),
        delivaryDate: new Date("2024-01-10"),
        mode: "ship",
      },
    ],
    status: "forecasted",
  },
  {
    id: "3",
    po: {
      id: "367190",
      cogs: 1200,
      orderDate: new Date("2024-01-03"),
      estCompleteDate: new Date("2024-01-18"),
    },
    so: [
      {
        id: "888192",
        shippingCost: 80,
        shipmentDate: new Date("2024-01-06"),
        delivaryDate: new Date("2024-01-12"),
        mode: "train",
      },
    ],
    status: "completed",
  },
  {
    id: "4",
    po: {
      id: "738450",
      cogs: 1300,
      orderDate: new Date("2024-01-04"),
      estCompleteDate: new Date("2024-01-25"),
    },
    so: [
      {
        id: "716252",
        shippingCost: 60,
        shipmentDate: new Date("2024-01-07"),
        delivaryDate: new Date("2024-01-14"),
        mode: "airplane",
      },
    ],
    status: "active",
  },
  {
    id: "5",
    po: {
      id: "236139",
      cogs: 900,
      orderDate: new Date("2024-01-05"),
      estCompleteDate: new Date("2024-01-28"),
    },
    so: [
      {
        id: "116287",
        shippingCost: 70,
        shipmentDate: new Date("2024-01-08"),
        delivaryDate: new Date("2024-01-15"),
        mode: "ship",
      },
    ],
    status: "forecasted",
  },
  {
    id: "6",
    po: {
      id: "381724",
      cogs: 1100,
      orderDate: new Date("2024-01-06"),
      estCompleteDate: new Date("2024-01-30"),
    },
    so: [
      {
        id: "772634",
        shippingCost: 90,
        shipmentDate: new Date("2024-01-08"),
        delivaryDate: new Date("2024-01-16"),
        mode: "train",
      },
    ],
    status: "completed",
  },
  {
    id: "7",
    po: {
      id: "993716",
      cogs: 1600,
      orderDate: new Date("2024-01-07"),
      estCompleteDate: new Date("2024-02-05"),
    },
    so: [],
    status: "active",
  },
];
